import { SpinnerSize } from './Spinner.types';

export const SPINNER_SIZE_IN_PX = {
  [SpinnerSize.XXS]: '12px',
  [SpinnerSize.XS]: '16px',
  [SpinnerSize.S]: '20px',
  [SpinnerSize.M]: '24px',
  [SpinnerSize.L]: '32px',
  [SpinnerSize.XL]: '48px',
  [SpinnerSize.XXL]: '64px',
};
